<template>
  <div v-if="show">
    <div class="reminder-modal-overlay" @click="closeModal">
      <div class="reminder-modal" @click.stop>
      <div class="reminder-header">
        <h2 class="reminder-title">Reminder Status</h2>
        <button class="close-btn" @click="closeModal">Close</button>
      </div>
      
      <div class="reminder-content">
        <div class="reminder-sections">
          <!-- Upcoming Reminders Section -->
          <div class="reminder-section ">
            <div class="section-header pending-section">
              <div class="section-icon pending-icon">
                <fluent-icon icon="clock" size="20" viewBox="0 0 15 15" />
              </div>
              <h3 class="section-title">Upcoming Reminders</h3>
            </div>
            
            <div class="reminder-list">
              <div v-if="loading" class="loading-state">
                <div class="loading-spinner"></div>
                Loading reminders...
              </div>
              <div v-else-if="upcomingReminders.length === 0" class="no-reminders">
                No upcoming reminders
              </div>
              <template v-else>
                <div 
                  v-for="reminder in upcomingReminders" 
                  :key="reminder.id"
                  class="reminder-item reminder-row"
                >
                  <div 
                  @click="contactProfileLink(reminder.id)"
                  class="reminder-contents cursor-pointer">
                   <div class="reminder-assignee">
                         {{ reminder?.assignee_name  || "No agent assign"}}
                   </div> 
                   <div class="reminder-text-with-avatar">
                        <div class="avatar-circle">
                        {{ reminder.name ? reminder.name.charAt(0).toUpperCase() : '' }}
                      </div>
                    <div>
                       <div class="assigneAgent  text-color">
                      {{ reminder.name ? reminder.name.substring(0, 14) : '' }}
                      </div>
                        <div class="reminder-text" v-tooltip="reminder.additional_attributes?.reminder_note">
                       Note:- {{ reminder.additional_attributes?.reminder_note.substring(0,100) || 'No note available' }} {{ reminder.additional_attributes?.reminder_note.length > 100 ? "..." : "" }}
                      </div>
                    </div>
                    </div>
                    <div class="reminder-date">{{ reminder.additional_attributes?.calendar_timings || 'No date available' }}</div>
                  </div>
                  <button
                    type="button"
                    class="reminder-mark-follow-up"
                       v-tooltip="{ content: 'Mark Reminder as Done', placement: 'left', classes: 'reminder-modal-tooltip' }"
                    @click.stop="openFollowUpModal(reminder)"
                    aria-label="Mark Follow up"
                  >
                    <fluent-icon icon="clock" size="18" viewBox="0 0 15.444 15.444" />
                  </button>
                </div>
              </template>
            </div>
          </div>

          <!-- Past Reminders Section -->
          <div class="reminder-section ">
            <div class="section-header completed-section">
              <div class="section-icon completed-icon">
                <fluent-icon icon="clock" size="20" viewBox="0 0 15 15" />
              </div>
              <h3 class="section-title">Pending Reminders</h3>
            </div>
            
            <div class="reminder-list">
              <div v-if="loading" class="loading-state">
                <div class="loading-spinner"></div>
                Loading reminders...
              </div>
              <div v-else-if="pastReminders.length === 0" class="no-reminders">
                No past reminders
              </div>
              <template v-else>
                <div 
                  v-for="reminder in pastReminders" 
                  :key="reminder.id"
                  class="reminder-item completed reminder-row"
                >
                  <div
                  @click="contactProfileLink(reminder.id)"
                  class="reminder-contents cursor-pointer">
                      <div class="reminder-assignee">
                         {{ reminder?.assignee_name || "No agent assingn"}}
                   </div> 
                   <div class="reminder-text-with-avatar">
                      <div class="avatar-circle">
                        {{ reminder.name ? reminder.name.charAt(0).toUpperCase() : '' }}
                      </div>
                    <div>
                       <div class="assigneAgent  text-color">
                        {{ reminder.name ? reminder.name.substring(0, 14) : '' }}
                      </div>
                        <div class="reminder-text" v-tooltip="reminder.additional_attributes?.reminder_note">
                       Note:- {{ reminder.additional_attributes?.reminder_note.substring(0,100) || 'No note available' }} {{ reminder.additional_attributes?.reminder_note.length > 100 ? "..." : "" }}
                      </div>
                    </div>
                    </div>
                    <div class="reminder-date">{{ reminder.additional_attributes?.calendar_timings || 'No date available' }}</div>
                  </div>
                  <button
                    type="button"
                    class="reminder-mark-follow-up"
                    v-tooltip="{ content: 'Mark Reminder as Done', placement: 'left', classes: 'reminder-modal-tooltip' }"
                    @click.stop="openFollowUpModal(reminder)"
                    aria-label="Mark Follow up"
                  >
                    <fluent-icon icon="clock" size="18" viewBox="0 0 15.444 15.444" />
                  </button>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="reminder-footer">
        <button class="close-footer-btn" @click="closeModal">Close</button>
      </div>
    </div>
    </div>

    <div v-if="showFollowUpModal && followUpContact" class="follow-up-modal-layer">
      <SetRemainderFollowUpModal
        :primary-contact="followUpContact"
        :show="showFollowUpModal"
        @close="toggleFollowUpModal"
        @success-message="onFollowUpSuccess"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SetRemainderFollowUpModal from 'dashboard/modules/contact/SetRemainderFollowUpModal.vue';

export default {
  name: 'ReminderModal',
  components: { SetRemainderFollowUpModal },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      upcomingReminders: [],
      pastReminders: [],
      currentPage: 1,
      perPage: 30,
      showFollowUpModal: false,
      followUpContact: null
    }
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      currentUser: 'getCurrentUser',
    })
  },
  watch: {
    show(newVal) {
      if (newVal) {
        this.fetchReminders();
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    async fetchReminders() {
        this.loading = true;
        try {
          const response = await axios.get(
            `/api/v1/accounts/${this.accountId}/get_all_reminders`,
            {
              params: {
                page: this.currentPage,
                per_page: this.perPage
              }
            }
          );

          if (response.data) {
            let upcoming = response.data.upcoming?.data || [];
            let past = response.data.past?.data || [];

            // ✅ Role-based filtering
            if (this.currentUser.role === 'agent') {
              upcoming = upcoming.filter(
                rem => rem.assignee_name === this.currentUser.name
              );
              past = past.filter(
                rem => rem.assignee_name === this.currentUser.name
              );
            }

            this.upcomingReminders = upcoming;
            this.pastReminders = past;
          }
        } catch (error) {
          console.error('Error fetching reminders:', error);
        } finally {
          this.loading = false;
        }
      },
      contactProfileLink(contact_id) {
        let baseUrl = `/app/accounts/${this.$route.params.accountId}/contacts/${contact_id}`;
        let url = this.pipelineContact ? `${baseUrl}?pipelineContact=true` : baseUrl;
        window.open(url, '_blank');
      },
      openFollowUpModal(reminder) {
        this.followUpContact = {
          id: reminder.id,
          additional_attributes: { ...(reminder.additional_attributes || {}) }
        };
        this.showFollowUpModal = true;
      },
      toggleFollowUpModal() {
        this.showFollowUpModal = false;
        this.followUpContact = null;
      },
      onFollowUpSuccess() {
        const contactId = this.followUpContact?.id;
        this.fetchReminders();
        this.$emit('refresh-board', contactId);
      },
    formatDate(dateString) {
      if (!dateString) return 'No date available';
      
      try {
        const date = new Date(dateString);
        const options = { 
          year: 'numeric', 
          month: 'short', 
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        };
        return date.toLocaleDateString('en-US', options);
      } catch (error) {
        return dateString; // Return original string if parsing fails
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.reminder-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.follow-up-modal-layer {
  position: fixed;
  inset: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
}

.reminder-modal {
  background: #FFFFFF;
  border-radius: 12px;
  width: 90%;
  max-width: 700px;
  max-height: 94vh;
  overflow: hidden;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.reminder-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  border-bottom: 1px solid #e5e7eb;
  background: #F8F9FA;
}

.reminder-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.close-btn {
 
  color: #6b7280;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 400;
  transition: background-color 0.2s;

  &:hover {
    color: #374151;
  }


}

.reminder-assignee {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 0.25rem;
}

.reminder-content {
  padding: 1.5rem;
  max-height: 60vh;
  overflow-y: auto;
}
.reminder-contents {
  padding: 1px;
  max-height: 60vh;
  overflow-y: auto;
}

.reminder-sections {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
}

.reminder-section {
  border-radius: 8px;
  overflow: hidden;
}

.pending-section {
  // background: #fff9e0;
  background: #f0fcef;

}

.completed-section {
  // background: #f0fcef;
    background: #fff9e0;

}

.section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.section-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
}

.pending-icon {
  background: #87af61;
  color: white;
}

.completed-icon {
  background: #a84017;
  color: white;
}

.section-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.reminder-list {
  max-height: 300px;
  overflow-y: auto;
}

.no-reminders {
  text-align: center;
  color: #6b7280;
  font-style: italic;
  padding: 2rem;
}
.reminder-text-with-avatar {
  display: flex;
  align-items: center;
  gap: 8px; /* space between circle and text */
}

.avatar-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #C2E1FF; /* or your theme color */
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #0090ff;
  font-size: 14px;
}

.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 2rem;
  color: #6b7280;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #e5e7eb;
  border-top: 2px solid #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.reminder-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  // padding: 0.75rem;
  // margin-bottom: 0.75rem;
  // background: white;
  // border-radius: 6px;
  // box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  padding: 10px 0;
  border-bottom: 1px solid #9ca3af !important;

  &:hover {
    transform: translateY(-1px);
  }

  &:last-child {
    margin-bottom: 0;
  }

  &.completed {
    opacity: 0.8;
  }
}

.reminder-row .reminder-contents {
  flex: 1;
  min-width: 0;
}

.reminder-mark-follow-up {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  margin-right: 1rem;
  border: none;
  border-radius: 6px;
  color: #2563eb;
  cursor: pointer;
  transition: background-color 0.2s, color 0.2s;

  &:hover {
    background: rgba(59, 130, 246, 0.25);
    color: #1d4ed8;
  }
}

.reminder-item:not(:last-child) {
  border-bottom: 1px solid #5c5959;
}

.reminder-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.reminder-text {
  font-weight: 500;
  color: #1f2937;
  margin-bottom: 0.25rem;
}
 .text-color {
  color: black;
  font-weight: 600;
}

.reminder-contact {
  font-size: 0.875rem;
  color: #6b7280;
  margin-bottom: 0.25rem;
  
  strong {
    color: #374151;
  }
}

.reminder-date {
  font-size: 0.78rem;
  color: #9ca3af;
  padding-left:2rem;
}

.reminder-actions {
  display: flex;
  gap: 0.5rem;
}

.reminder-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e5e7eb;
  background: #F8F9FA;
  text-align: center;
}

.close-footer-btn {
  background: #d1d5db;
  color: #374151;
  border: none;
  padding: 0.75rem 2rem;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background: #9ca3af;
  }
}

// Dark mode support
body.dark {
  .reminder-modal {
    background: #1f2937;
    color: #f9fafb;
  }

  .reminder-header {
    background: #374151;
    border-bottom-color: #4b5563;
  }

  .reminder-title {
    color: #f9fafb;
  }

  .pending-section {
    background: #451a03;
  }

  .completed-section {
    background: #064e3b;
  }

  .reminder-item {
    background: #374151;
    
    &.completed {
      background: #1f2937;
    }
  }

  .reminder-text {
    color: #f9fafb;
  }

  .reminder-contact {
    color: #d1d5db;
    
    strong {
      color: #f3f4f6;
    }
  }

  .reminder-date {
    color: #9ca3af;
  }

  .no-reminders {
    color: #9ca3af;
  }

  .reminder-footer {
    background: #374151;
    border-top-color: #4b5563;
  }
}

// Responsive design
@media (max-width: 768px) {
  .reminder-sections {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .reminder-modal {
    width: 95%;
    margin: 1rem;
  }

  .reminder-item {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }

  .reminder-date {
    margin: 0;
  }
}
</style> 
<style lang="scss">
/* Tooltip above reminder modal - not scoped so it applies when tooltip is rendered in body */
.reminder-modal-tooltip {
  z-index: 1100 !important;
}
</style> 